export default __webpack_public_path__ + "static/teaserImageLogin-dd935ae471f1a67b22b04fae7f558ae9.jpg";